<template>
  <div class="base-input">
    <div class="text-field">
      <input
          type="text"
          :title="title"
          :placeholder="placeholder"
          v-model="localValue"
          @input="$emit('input', localValue)"
      />
    </div>
    <div
        v-if="clearable"
        @click="clear"
        :class="clearButtonClasses"
    >
      <CloseIcon color="#6a6a6a"/>
    </div>
  </div>
</template>

<script>
import CloseIcon from "@/components/icons/CloseIcon";
export default {
  name: "BaseInput",
  components: {CloseIcon},
  props: {
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.localValue = v;
      }
    },
  },
  data: () => ({
    localValue: '',
  }),
  computed: {
    clearButtonClasses() {
      return {
        'btn-clear': true,
        'btn-clear__hidden': !this.localValue,
      };
    }
  },
  methods: {
    clear() {
      this.$emit('input', '');
    }
  }
}
</script>

<style scoped>
.base-input {
  display: flex;
  appearance: none;
  border: 1px solid #CFD2D3;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 4px 10px 4px 20px;
  text-align: center;
  box-shadow: none;
  width: 100%;
  background-color: #fff;
}

.base-input:focus-within {
  border-color: #F68C1E;
}

.text-field {
  display: flex;
  flex: 1 1 auto;
  text-align: center;
}

.text-field input, .text-field input:focus, .text-field input:active {
 outline: none;
}

.text-field input {
  flex: 1 1 auto;
  max-width: 100%;
  min-width: 0;
  width: 100%;
  background-color: transparent;
  border-style: none;
  text-align: center;
}

.btn-clear {
  cursor: pointer;
  width: 24px;
  height: 24px;
  margin-top: 3px;
  user-select: none;
  display: inline-flex;
}

.btn-clear__hidden {
  visibility: hidden;
}
</style>
